export function NestleNutrirNoviembrePage() {
  return (
    <iframe
      src="/dash/nestle/nutrir/noviembre.html"
      title="Nutrir es Acompañar — Nestlé Health Science"
      style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
    />
  )
}
